// extracted by mini-css-extract-plugin
export var container = "_dw-0";
export var infoIcon = "_dw-2";
export var titleRowCol = "_dw-1";